import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@shared/config/routes'
import logoUrl from '@/assets/images/logo.svg'
import styles from './DocumentPage.module.css'

interface DocumentPageProps {
  title: string
  children: ReactNode
}

/**
 * Общий layout для текстовых страниц (политика, соглашение):
 * логотип сверху, заголовок, контент, снизу две кнопки (Назад / Войти в Secret chat).
 */
export const DocumentPage = ({ title, children }: DocumentPageProps) => {
  const navigate = useNavigate()

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <img src={logoUrl} alt="Secret Chat" className={styles.logo} />
        <div className={styles.content}>
          <h1 className={styles.title}>{title}</h1>
          <div className={styles.body}>{children}</div>
        </div>
        <div className={styles.footer}>
          <button
            type="button"
            className={`${styles.btn} ${styles.btnBack}`}
            onClick={() => navigate(ROUTES.AUTH)}
          >
            <svg className={styles.chevron} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.5 1.5L3 5l3.5 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Назад
          </button>
          <button
            type="button"
            className={`${styles.btn} ${styles.btnPrimary}`}
            onClick={() => navigate(ROUTES.AUTH)}
          >
            Войти в Secret chat
          </button>
        </div>
      </div>
    </div>
  )
}
